
export const chatEndpoints = {
    getMessagingConversations: '/messaging/conversations/',
    getMessagingMessages: '/messaging/instagram-messages/',
    getMessagingMessagesOnOff: '/messaging/instagram-on-off/',
    getMessagingMessagesWhatsapp: '/messaging/whatsapp-messages/',
    getMessagingMessagesWhatsappOnOff: '/messaging/whatsapp-on-off/',
    getMessagingHalperMessages: '/messaging/halper-messages-list/',
    postMessagingHalperResponse: '/messaging/halper-response/',
    getMessagingCommunities: '/community/communities/',
    postCommunityJoin: '/community/community-join/',
    getMessagingCommunityMessages: '/community/community-messages/',
    postMessagingCommunityPost: '/community/community-message-post/',
    postCommunityLeave: '/community/community-leave/',
    getMessagingJoinedCommunities: '/community/joined-communities/',
    getNotification: '/community/community-notification/',
    getNotificationCheck: '/community/community-notification-check/',
    getMessagingCommunityMembers: '/community/community-members/',
    postMessagingHalperMessageReact: '/messaging/halper-message-react/',
    postMessagingChatMessageReact: '/messaging/chat-message-react/',
    getHalperChatUnreadCount: '/messaging/halper-message-unread-count/',
    postHalperMarkAsRead: '/messaging/halper-messages-mark-as-read/',
};